<template>
  <section class="sec sec-05 mt-5 mb-5 sec-padding">
    <div class="sec-05 sec-05-hex">
      <div class="model1"> <span class="blue-light"></span></div>
      <div class="model2"> 
        <span class="blue-light"></span>
        <span class="blue-light"></span>
        <span class="blue-light"></span>

      </div>
      
    </div>
    <div class="container-fluid">
      <div class="row mb-5">
        <div class="sec-title">
          <h1 class="wow fadeInUp has-u-line" data-wow-duration="1s" data-wow-delay=".5s" v-html="title"></h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="sec-05-fc">
             <img class="hidden  base-img1" src="/theme/img/base-lines.svg">
             <img class="hidden  base-img2" src="/theme/img/base-lines-mob.svg">
            <div class="row fc-con">
              <span class="points">
                 <span class="p1"></span><span class="p2"></span> <span class="p3"></span>
                 <span class="p4"></span><span class="p5"></span><span class="p6"></span>
               </span>
               <div class="fc-img-con">
                  <div class="ft-img" v-for="item in fcData" :key="item.img"><img :src="item.img"></div>
               </div>
               <div class="fc-txt-con">
                 <div class="ft-text" v-for="item in fcData" :key="item.h4">
                        <h4 v-html="item.h4"></h4>
                        <p v-html="item.p"></p>
                  </div>
               </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style  scoped>

  .model1{
   width: 100%;
    height: 100%;
    position: absolute;
    top: -8%;
}
.model1::before {
    content: '';
    background: url("/theme/img/sec-5-model1.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 0% 0%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 0.9;
}
.model1 .blue-light:nth-child(1){
    right: 3%;
    left: unset;
    top: 4%;
}
.model2 .blue-light{
  top: unset;
  bottom: 0%;
}
.model2 .blue-light:nth-child(1){
  bottom: 31.5%;
    left: .5%;
    animation-duration: 2.1s;
    -webkit-animation-duration: 2.1s;
}
.model2 .blue-light:nth-child(2){
      bottom: 20.6%;
    left: 6.5%;
     animation-duration: 2.6s;
    -webkit-animation-duration: 2.6s;
}
.model2 .blue-light:nth-child(3){
     bottom: 9.6%;
    left: 0.5%;
     animation-duration: 2.3s;
    -webkit-animation-duration: 2.3s;
}

 .model2{
   width: 100%;
    height: 100%;
    position: absolute;
    bottom:-12%;
}
.model2::before {
  content: '';
    background: url(/theme/img/sec-5-model2.svg);
    background-size: 33%;
    background-repeat: no-repeat;
    background-position: -23% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 0.9;
}
.fc-con .points{
   width: 100%;
    position: absolute;
     z-index: 1;
    height: 100%;
}
.fc-con .points span{
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #fff;
    display: inline-block;
    box-shadow: 0px 0px 14px 0px rgb(55 162 204);
    position: absolute;
    transform: translate(-100% , 0%);
    user-select: none;
    pointer-events: none;
    opacity: 0;
}

.fc-con .points span{
    top: 9.6%;
    left: 21%;
}
.fc-con .points span.p1{
  animation: mover1 50s ease-in-out infinite;
}
.fc-con .points span.p2{
  animation: mover1 50s ease-in-out infinite;
  animation-delay: 10s;
}
.fc-con .points span.p3{
  animation: mover1 50s ease-in-out infinite;
  animation-delay: 20s;
}
.fc-con .points span.p4{
  animation: mover1 50s ease-in-out infinite;
  animation-delay: 30s;
}
.fc-con .points span.p5{
  animation: mover1 50s ease-in-out infinite;
  animation-delay: 40s;
}
.fc-con .points span.p6{
  animation: mover1 50s ease-in-out infinite;
  animation-delay: 45s;
}
@keyframes mover1 {
  /* stage1 */
  0%{
    top: 9.6%;
    left: 21%;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    opacity: 1;
  }
  4%{
    box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }

  13%{
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
     opacity: 1;
  }
  15%{
    top: 9.6%;
    left: 54%;
    opacity: 0;
  }
  /* stage2 */
  16%{
    top: 10.5%;
    left: 54.8%;
    opacity: 1;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  18%{
     opacity: 1;
  }
  20%{
    top: 17%;
    left: 53.2%;
    opacity: 0;
  }
  /* stage3 */
  21%{
    top: 17.3%;
    left: 53.2%;
    box-shadow: 0px 0px 14px 8px rgb(55 162 204);
    opacity: 1;
  }
  27%{
     opacity: 1;
  }
  29%{
    top: 17.3%;
    left: 92%;
    opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage4 */
  30%{
    top: 18.3%;
    left: 92.6%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  33%{
     opacity: 1;
  }
  34%{
    top: 33.3%;
    left: 87.7%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage5 */
  35%{
    top: 34.2%;
    left: 86%;
    opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  44%{
     opacity: 1;
  }
  45%{
    top: 34.2%;
    left: 17%;
      opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage6 */
  46%{
    top: 35.2%;
    left: 16.2%;
    opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  53%{
     opacity: 1;
  }
  54%{
    top: 65.2%;
    left: 7.2%;
      opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage7 */
  55%{
    top: 66.2%;
    left: 8%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  62%{
     opacity: 1;
  }
  63%{
    top: 66.2%;
    left: 51%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage8 */
  64%{
    top: 65.2%;
    left: 52.3%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  68%{
     opacity: 1;
  }
  69%{
    top: 54.2%;
    left: 56.2%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
   /* stage9 */
  70%{
    top: 53.5%;
    left: 57.2%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  73%{
     opacity: 1;
  }
  74%{
    top: 53.5%;
    left: 70%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage10 */
  75%{
    top: 54.5%;
    left: 70.2%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  78%{
     opacity: 1;
  }
  79%{
    top: 78%;
    left: 64.8%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage11 */
  80%{
    top: 78.4%;
    left: 65.8%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  83%{
     opacity: 1;
  }
  84%{
   top: 78.4%;
    left: 94%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  /* stage12 */
  85%{
    top: 79.4%;
    left: 94.8%;
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  89%{
     opacity: 1;
  }
  90%{
     top: 96.4%;
     left: 88.8%;
     opacity: 0;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
  }
  95%{
     opacity: 1;
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
  }
  /* stage13 */
   99%{
     opacity: 1;
  }
  100%{
    top: 96.4%;
    left: 28.8%;
    opacity: 0;
  }
}
@media (max-width: 480px) {
    .fc-con .points ,.sec-05-hex{
      display: none;
    }
        
}


</style>
<script>
import ScrollMagic from "scrollmagic";
import helpers from '@/plugins/helpers' 

export default {
   props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  },
   data(){
    return{
      fcData:[{
        h4:"End-to-end fully automated trading system",
        p:"We provide a hand-free trading system with minimum human interactions which helps you attain financial and time freedom.",
        img:"/theme/img/end-to-end.png"
      },
      {
        h4:"Strong backend infrastructure",
        p:"We took special care to assure that your trading is executed in a reliable system by building a strong backend infrastructure.",
        img:"/theme/img/strong-backend.png"
      },
      {
        h4:"Scalable trading models",
        p:"Our AI-driven trading model will secure the scalability of the trading system over time, ensuring exponential growth.",
        img:"/theme/img/scalable.png"
      },
      {
        h4:"Seamless Strategy Deployment",
        p:"AlphaQ makes trading a joyride by making the selection and application of strategies seamless.",
        img:"/theme/img/seamless-stratergy.png"
      },
       {
        h4:"Stringent Risk Management System",
        p:"With the power of AI, our system calculates and regulates risks, ensuring the minimum impact of unprecedented issues.",
        img:"/theme/img/straingent.png"
      },
      {
        h4:"Transparent transactions using coin-based subscription",
        p:"Our subscription packages utilize a coin-based process, making the transaction and charges inflicted crystal clear and easily recognizable.",
        img:"/theme/img/coin-subscription.png"
      },
      {
        h4:"Advisory and Algorithm based dual Impact system",
        p:"AlphaQ takes your trading journey to new dimensions by joining hands of human expertise with the power of AI. We provide options for expert advisory from verified SEBI traders and highly optimized algorithms.",
        img:"/theme/img/advisory.png"
      }
      ]
    }
  },
  mounted() {
     this.onscrollHandler()
   },
  methods: {
    onscrollHandler() {
      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: ".sec-05",
        offset: window.innerHeight * 0.46,
        duration: helpers.isMobile()?"10%":"30%",
      }).setPin(".sec-05");
       scene.on("enter progress", function (e) {
        if (e.scrollDirection == "FORWARD") {
          if (e.progress >0){
            document.querySelector('.sec-05  .has-u-line').classList.add('sec-active')
          }
        }else if (e.scrollDirection == "REVERSE") {
           if (e.progress ==0){
            document.querySelector('.sec-05 .has-u-line').classList.remove('sec-active')
          }
        }})
      controller.addScene([scene]);
    }
  }
};
</script>